/**
 * Normalize a user-provided website/discord URL:
 * - Trim whitespace
 * - Prepend https:// if scheme missing
 * - Return empty string when input is empty/invalid
 */
export function normalizeWebUrl(input?: string | null): string {
  if (!input) return '';
  let v = String(input).trim();
  if (!v) return '';
  // Strip leading "//" (protocol-relative)
  v = v.replace(/^\/\/+/, '');
  // If it already has a scheme, keep it (but force http(s) only)
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(v)) {
    if (!/^https?:\/\//i.test(v)) return '';
    return v;
  }
  // Otherwise prepend https://
  return `https://${v}`;
}
